import styled from 'styled-components';

const StyledIconWrapper =styled.div`
    color: ${props => props.theme.textColor};
    margin-bottom: 10px;
`;

export default StyledIconWrapper;


// WEBPACK FOOTER //
// ./components/utils/Styled/blankIconWrapper.js